import { Navigate } from 'react-router-dom';
import { useCapabilities, hasCapability } from '../hooks/useCapabilities.js';

/**
 * CapGate — LEGAL-PAGE-AND-PROVISION-TEMPLATES-1 Part 3.
 *
 * Route-level guard for pages whose backend is requireTenantTable-gated. When
 * the tenant's DB lacks the backing table, a direct URL hit redirects to the
 * dashboard instead of drawing a page shell the backend will 404. Renders
 * nothing while the capability signal loads. Companion to the `cap:` nav-link
 * flag in Layout.jsx (which hides the sidebar entry).
 *
 * Usage: <Route element={<AdminRoute element={<CapGate cap="RochHistoricalSales" element={<RevenuesDashboard />} />} />} />
 */
export default function CapGate({ cap, element }) {
  const caps = useCapabilities();
  if (caps === null) return null;
  return hasCapability(caps, cap) ? element : <Navigate to="/dashboard" replace />;
}
